import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import format from 'date-fns/format';
import cx from 'classnames';
import { InfoOutlined } from '@material-ui/icons';
import Input, { INPUT_TYPES } from '../Input/Input';

const BannerChangesetRow = props => {
  const { draft, totalApprovals } = props;
  return (
    <motion.tr
      exit={{ opacity: 0, x: '30%' }}
      transition={{
        ease: [0.18, 0.89, 0.39, 1.4],
        duration: 0.3,
      }}
      positionTransition
      key={draft.id}
      className={cx({
        'bg-lightYellow': draft.operation_type === 'UPDATE',
        'bg-lightGreen': draft.operation_type === 'CREATE',
        'bg-lightRed': draft.operation_type === 'DELETE',
      })}>
      <td className="p-2">
        <Input
          id={draft.id}
          name={draft.id}
          type={INPUT_TYPES.CHECKBOX}
          onChange={props.toggleRowSelection}
          checked={props.selected[draft.id]}
          inputClassName="box_checkbox"
        />
      </td>
      <td className="p-2">{draft.modified_by}</td>
      <td className="p-2">{format(new Date(draft.modified_at), 'd MMM yyyy')}</td>
      <td className="p-2 max-w-xs">
        <div className="flex">
          <div className="icon_preview rounded w-16 h-16 mr-4 flex-none">
            {draft.icon && (
              <img src={draft.icon} width="100%" alt="banner icon" />
            )}
          </div>
          <div className="text-sm">
            <div>
              <strong>Title:</strong> {draft.title}
            </div>
            <div className="mt-2">
              <strong>Description:</strong> {draft.description}
            </div>
            {Boolean(draft.contexts.length) && (
              <ul className="list-reset mt-2">
                Contexts:
                {draft.contexts.map(context => {
                  return (
                    <li key={context.key} className="flex">
                      <div className="mr-4">
                        <strong>Key:</strong> {context.key}
                      </div>
                      <div>
                        <strong>Value:</strong> {context.value}
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        </div>
      </td>
      <td className="draft_approvers p-2">
        <span>{`${totalApprovals}/2`}</span>
        {Boolean(totalApprovals) && (
          <InfoOutlined className="cursor-pointer" fontSize="small" />
        )}
        {Boolean(totalApprovals) && (
          <span className="draft_approvers__list">
            {draft.first_approver}, {draft.second_approver}
          </span>
        )}
      </td>
    </motion.tr>
  );
};

BannerChangesetRow.propTypes = {
  draft: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  toggleRowSelection: PropTypes.func.isRequired,
  totalApprovals: PropTypes.number.isRequired,
};

export default  BannerChangesetRow;
